<script>
	import { onMount } from "svelte";
	import Question from "./Question.svelte"; //each question template
	import correctCount from "./correct-count-store.js"; //tracking how many questions were selected correctly
	import nextq from "./next-question-number-store.js"; //tracking which number question comes next to show/hide next/previous
	export let allQuizData;
	//import * as quizData from "./quizTemplate.json"; //all of the quiz data as JSON
	console.log("I'm the console");
	let quizData = allQuizData;
	const questionCount = quizData.quiz.questionList.length; //total number of quiz questions
</script>

<div
	class="background"
	style="background-image: url({quizData.quiz.quizBackgroundImage.url})"
>
	<span class="attribution"
		>{quizData.quiz.quizBackgroundImage.attribution}</span
	>
	<div class="wrapper">
		<div class="landing {$nextq === 0 ? 'show' : 'hide'}">
			<h1>{quizData.quiz.intro.title}</h1>
			<p>{quizData.quiz.intro.introText}</p>
			<p
				data-track-event="{quizData.quiz.intro
					.title}|Button Click|Start Quiz"
				class="start"
				on:click={() => nextq.update((n) => n + 1)}
			>
				Start Quiz
			</p>
		</div>

		{#each quizData.quiz.questionList as questionList, index}
			<div class={$nextq === index + 1 ? "show" : "hide"}>
				<Question
					quizTitle={quizData.quiz.intro.title}
					questionWrapper={questionList}
					questionNumber={index + 1}
					{questionCount}
				/>
			</div>
		{/each}

		<div class="final {$nextq === questionCount + 1 ? 'show' : 'hide'}">
			<h2>
				You got {$correctCount} out of {questionCount} questions correct!
			</h2>
			<p>{quizData.quiz.closing.closingText}</p>
		</div>
	</div>
</div>

<style>
	.background {
		width: 100vw;
		min-height: calc(100vh - 8vw);
		background-size: cover;
		background-attachment: fixed;
		margin: 0;
		padding: 4vw 0;
		position: relative;
	}
	.background .attribution {
		position: absolute;
		bottom: 5px;
		right: 5px;
		color: rgba(255, 255, 255, 0.9);
		text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.75);
		font-size: 0.8em;
	}
	.wrapper {
		max-width: 800px;
		width: 100%;
		padding: 25px;
		margin: 0 auto;
		background-color: #fff;
		position: relative;
	}
	div.landing,
	div.final {
		text-align: center;
	}
	p.start {
		display: block;
		background-color: #ffaf4f;
		padding: 15px 10px;
		margin: 20px auto;
		color: #222;
		font-weight: bold;
		text-align: center;
		max-width: 200px;
		font-size: 1.2rem;
		transition: background-color 0.25s linear;
	}
	p.start:hover {
		background-color: #f6941e;
	}
	.show {
		display: block;
	}
	.hide {
		display: none;
	}
	@media screen and (max-width: 800px) {
		.wrapper {
			left: 0;
			padding: 3vw;
			width: 94vw;
		}
	}
</style>
